(function($, undefined) {
	
	'use strict';
	var addStoryBtn;
	var storiesBackBtn;
	var field5Switch;

	var showStoryForm = function() {
		var ctn = $('.admin-stories-list-ctn');
		var storiesForm = $('.add-stories-form-ctn');
		ctn.hide();
		storiesForm.show();
	};

	var hideStoryForm = function() {
		var ctn = $('.admin-stories-list-ctn');
		var storiesForm = $('.add-stories-form-ctn');
		ctn.show();
		storiesForm.hide();
	};

	var updateStoryStatus = function() {
		var form = $(this).closest('form');
		var storyId = $(this).attr('id');
		var status = $(this, form).prop('checked');

		form.addClass('processing');

		var action = "/action/manageGenData";
		var params = {
			ajax: true,
			field5: status
		};
		if (storyId) {
			params.id = storyId;
		}
		$.ajax({
			url: action,
			method: "post",
			data: params,
			complete: function(response) {
				console.log(response.responseText);
				console.log(params);
				if (response.responseText.indexOf('success') !== -1) {
					location.reload();
				} else {
					form.removeClass('processing');
				}
			}
		});
	};
	
	var init = function () {
		addStoryBtn = $('.add-story-btn');
		storiesBackBtn = $('.stories-back-btn');
		field5Switch = $('[name=field5-switch]');
		
		addStoryBtn.on('click', showStoryForm);
		storiesBackBtn.on('click', hideStoryForm);
		field5Switch.change(updateStoryStatus);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
